/**
 * 积分任务
 * @returns
 */

import {
  Box,
  Flex,
  Text,
  Image,
  Button,
  HStack,
} from "@chakra-ui/react";
import Integral1 from "@/assets/images/integral_img1.png";
import Integral2 from "@/assets/images/integral_img2.png";
import Integral3 from "@/assets/images/integral_img3.png";
import{Task} from "@/types/task";


type Props = {
  task: Task;
  isCompleted: boolean;
}

const IntegralTaskItem = ({task, isCompleted}:Props) => {
  const {task_name, task_reward } = task;
  return (
    <Flex
      justifyContent={"space-between"}
      alignItems="center"
      pl="20px"
      pr="20px"
      w="100%"
      pt="5px"
      pb="5px"
      // h="81px"
      minH={"94px"}
      // boxSizing="border-box"
      // border={"1px solid #DCE0EB"}
    >
      <Flex alignItems={"center"}>
        <Image boxSize={"32px"} src={Integral2} />
        <Box ml="30px">
          <HStack mb="4px" fontSize={"14px"} color={"#333333"}>
            <Text mr="20px">{task_name}</Text>
            <Image src={`${Integral3}`} />
            <Text>+{task_reward}</Text>
          </HStack>
          <Box color={"#8E94A9"} fontSize={"12px"}>
          {task_name}，立即获得+{task_reward}积分
          </Box>
        </Box>
      </Flex>
      <Box>
        <Button
          display={isCompleted? "block" : "none"}
          borderRadius={"40px"}
          width={"68px"}
          height={"30px"}
          color="#27314D"
          bgColor="#fff"
          fontWeight={"normal"}
          border={"1px solid #8E94A9"}
          fontSize="12px"
          _hover={{
            bgColor: "#CBD1DF",
            border: "1px solid #8E94A9",
          }}
        >
          已完成
        </Button>
        <Button
          display={isCompleted? "none" : "block"}
          borderRadius={"40px"}
          width={"68px"}
          height={"30px"}
          color="#FFFFFF"
          bgColor="#496AE1"
          fontWeight={"normal"}
          fontSize="12px"
          _hover={{
            bgColor: "#3F5BC1",
            color: "#E6E6E6",
          }}
        >
          去完成
        </Button>
      </Box>
    </Flex>
  );
};

export default IntegralTaskItem;
